import { c as _c } from "react/compiler-runtime";
import { useHotelSortView } from "@website/accommodation-ui/hotel-list-header/hotel-sort-view/hotel-sort-view.hook";
import { HotelSortViewPropertiesType } from "@website/accommodation-ui/hotel-list-header/hotel-sort-view/hotel-sort-view.types";
import { Button } from "@website/ui/button";
import { MiniPopover } from "@website/ui/mini-popover";
import { Radio } from "@website/ui/radio";
import { FC } from "react";
export const HotelSortView: FC<HotelSortViewPropertiesType> = properties => {
  const $ = _c(17);
  const {
    buttonProps,
    popoverProps,
    radioProps
  } = useHotelSortView(properties);
  let t0;
  if ($[0] !== buttonProps) {
    t0 = <Button {...buttonProps} className="truncate" />;
    $[0] = buttonProps;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== radioProps.checkedRadio || $[3] !== radioProps.list || $[4] !== radioProps.onChangeRadio) {
    let t2;
    if ($[6] !== radioProps.checkedRadio || $[7] !== radioProps.onChangeRadio) {
      t2 = item => <Radio key={item.label} {...item} checked={radioProps.checkedRadio === item.value} className="my-3 text-sm" color="secondary" name="radiobutton" onChange={radioProps.onChangeRadio} />;
      $[6] = radioProps.checkedRadio;
      $[7] = radioProps.onChangeRadio;
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    t1 = radioProps.list.map(t2);
    $[2] = radioProps.checkedRadio;
    $[3] = radioProps.list;
    $[4] = radioProps.onChangeRadio;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[9] !== t1) {
    t2 = <div className="flex flex-1 flex-col overflow-hidden"><div className="flex flex-1 overflow-hidden px-3.5"><div>{t1}</div></div></div>;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] !== popoverProps || $[12] !== t2) {
    t3 = <MiniPopover {...popoverProps}>{t2}</MiniPopover>;
    $[11] = popoverProps;
    $[12] = t2;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[14] !== t0 || $[15] !== t3) {
    t4 = <div className="relative">{t0}{t3}</div>;
    $[14] = t0;
    $[15] = t3;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  return t4;
};